import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ObjectionSection() {
  return <section className="w-full py-20 px-6 bg-cream" data-id="element-117">
      <div className="max-w-reading mx-auto" data-id="element-118">
        {/* Objection Handling */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-119">
          <h2 className="text-3xl font-bold text-navy mb-6" data-id="element-120">
            “But I already have notes…”
          </h2>
          <p className="text-lg text-body mb-4" data-id="element-121">
            That’s the point. Most moms already have a messy “system”: notes
            app, portal screenshots, paper discharge instructions, photos of
            labels, a folder called “medical” with 400 images.
          </p>
          <p className="text-lg font-medium text-navy italic mb-8" data-id="element-122">
            It’s not that you have nothing. It’s that you don’t have a structure
            that works during panic.
          </p>

          <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-123">
            <h3 className="text-lg font-bold text-navy mb-4 border-b border-gray-100 pb-2" data-id="element-124">
              Why old solutions fail
            </h3>
            <ul className="space-y-3" data-id="element-125">
              <li className="flex items-start gap-3 text-muted" data-id="element-126">
                <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-127" />
                <span data-id="element-128">Apps require upkeep and calm attention.</span>
              </li>
              <li className="flex items-start gap-3 text-muted" data-id="element-129">
                <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-130" />
                <span data-id="element-131">Pretty planners are built for predictable routines.</span>
              </li>
              <li className="flex items-start gap-3 text-muted" data-id="element-132">
                <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-133" />
                <span data-id="element-134">
                  Phone notes collapse when you’re under time pressure.
                </span>
              </li>
              <li className="flex items-start gap-3 text-muted" data-id="element-135">
                <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-136" />
                <span data-id="element-137">Your memory is not designed to be a medical record.</span>
              </li>
            </ul>
          </div>
        </motion.div>

        {/* What's Inside */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-138">
          <h2 className="text-3xl font-bold text-navy mb-8 text-center" data-id="element-139">
            What you get inside (the kit)
          </h2>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-140">
            {['1‑Page Medical Snapshot (fillable + print)', 'Allergies + Reactions page', 'Current Medication Map + History', 'Symptom + Trigger Log (fast, low-maintenance)', 'Care Team Contacts page', 'Appointment Script card (what to say)', 'Questions for the Visit sheet', 'Tests/Results Index + filing labels', 'Post‑Visit Action Sheet', 'Weekly Care Loop checklist', 'Optional: School/Daycare Quick Sheet', 'Optional: Babysitter Instructions'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-3 rounded-lg border border-soft-sage/30" data-id="element-141">
                <Check className="w-4 h-4 text-teal flex-shrink-0" data-id="element-142" />
                <span className="text-sm md:text-base text-body" data-id="element-143">{item}</span>
              </div>)}
          </div>

          <div className="mt-8 text-center" data-id="element-144">
            <p className="text-muted text-sm" data-id="element-145">
              Everything is built to be printable, simple, usable without
              perfection, and readable in a fluorescent-lit room at night.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}